(() => {
  const cards = [...document.querySelectorAll(".point-card")];
  const pointsStack = document.querySelector(".points-stack");
  const faqItems = [...document.querySelectorAll(".faq details")];
  const aboutPhotos = [...document.querySelectorAll(".photo-stack__item")];
  const cardPhotoGroups = [...document.querySelectorAll(".card-photos")];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const setStickyOffsets = () => {
    const stepX = Math.min(18, Math.max(10, window.innerWidth * 0.012));
    const stepY = Math.min(11, Math.max(7, window.innerWidth * 0.0065));
    const horizontalPattern = [1, 2, 0, 1.5];

    // Keep a two-step horizontal lane and scatter the four cards across it.
    // This exposes alternating left and right edges instead of one rightward fan.
    pointsStack?.style.setProperty("--stack-total-shift", `${stepX * 2}px`);
    pointsStack?.style.setProperty("--stack-total-shift-y", `${stepY * 3}px`);

    cards.forEach((card, index) => {
      const horizontalStep = horizontalPattern[index] ?? index % 2;
      card.style.setProperty("--stack-shift-x", `${horizontalStep * stepX}px`);
      card.style.setProperty("--stack-shift-y", `${index * stepY}px`);
      card.style.zIndex = String(index + 1);
    });

    if (reduceMotion.matches) return;

    const tallestCard = Math.max(...cards.map((card) => card.offsetHeight));
    const baseTop = Math.min(56, window.innerHeight - tallestCard);

    cards.forEach((card, index) => {
      // The reference site pins tall panels with their bottom edge in view.
      // Short panels use a comfortable top gutter. The visible vertical step is
      // applied with a transform so it remains at both the top and bottom edges.
      const top = baseTop;
      card.style.setProperty("--sticky-top", `${Math.round(top)}px`);
    });
  };

  faqItems.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      faqItems.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  aboutPhotos.forEach((photo) => {
    photo.addEventListener("click", () => {
      aboutPhotos.forEach((other) => other.classList.toggle("is-active", other === photo));
    });
  });

  cardPhotoGroups.forEach((group) => {
    const photos = [...group.querySelectorAll(".card-photos__item")];

    photos.forEach((photo) => {
      photo.addEventListener("click", () => {
        photos.forEach((other) => other.classList.toggle("is-active", other === photo));
      });
    });
  });

  document.querySelectorAll('[aria-disabled="true"]').forEach((link) => {
    link.addEventListener("click", (event) => event.preventDefault());
  });

  window.addEventListener("resize", setStickyOffsets, { passive: true });
  window.addEventListener("load", setStickyOffsets, { once: true });
  reduceMotion.addEventListener?.("change", setStickyOffsets);
  setStickyOffsets();
})();
